import { createApp } from 'vue'
import StafetDonationTaendLysStepOne from './StafetDonationTaendLysStepOne'

const el = '.kb-component--stafet-donation-taend-lys-step-one'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDonationTaendLysStepOneDOM) => {
            const component = createApp(StafetDonationTaendLysStepOne).use(
                Store
            )
            component.mount(StafetDonationTaendLysStepOneDOM)
        })
    }
}
